import { cloneElement } from 'react';
import {
    Datagrid,
    DatagridProps,
    DateField,
    DateInput,
    ListToolbar,
    // NumberField,
    // ChipField,
    // ReferenceInput,
    // SelectInput,
    // AutocompleteInput,
    TextInput,
    // FunctionField,
    Pagination,
    PaginationProps,
    useListContext,
} from 'react-admin';
import { Box, Card, CardContent, useMediaQuery } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';

import { FC } from 'react';

// import TransactionTypes from '../transactions/TransactionTypes'
import { CurrencyFormatInput, dateLocales, currencyFormatter, defaultDateOptions } from '../utils/formatters';
import ListActions from '../components/ToolbarActions';
import CustomNumberField from '../components/customNumber';
import StackedBarchart from './StackedBarchart';

const useStyles = makeStyles(theme => ({
    amount: { fontWeight: 'bold' },
    openIcon: { width: '1rem', height: '1rem' },
    chip: (type: any) => ({
        backgroundColor: type.color,
        color: '#FFF'
    }),
    chipFinancing: {
        backgroundColor: theme.palette.primary.light,
        color: '#FFF'
    },
    cardChart: {
        display: 'flex',
        alignItems: 'center',
        justifyItems: 'center',
        flexDirection: 'column',
        height: 300,
    },
}))

// const types = TransactionTypes()
const transactionFilters = [
    // <NumberInput source="id" />,
    // <SelectInput source="type@_eq" choices={types} alwaysOn />,
    <DateInput source="timestamp@_gte" />,
    <DateInput source="timestamp@_lte" />,
    // <ReferenceInput
    //     source="financing_id"
    //     reference="Financing"
    //     sort={{ field: 'id', order: 'ASC' }}
    //     // filterToQuery={id => ({ id })}
    //     perPage={10}
    // // defaultValue={84}
    // >
    //     <SelectInput source="amount" optionText="id" optionValue="id" />
    // </ReferenceInput>,
    <TextInput
        source="value@_gte"
        InputProps={{
            inputComponent: CurrencyFormatInput,
        }}
    />,
    <TextInput
        source="value@_lte"
        InputProps={{
            inputComponent: CurrencyFormatInput,
        }}
    />,
]

const CustomPagination = (props: JSX.IntrinsicAttributes & PaginationProps) =>
    <Pagination rowsPerPageOptions={[10, 25, 50]} {...props} />;


interface ListChartViewProps extends DatagridProps {
    repaymentRate: number;
}




const ListChartView: FC<ListChartViewProps> = props => {
    const classes = useStyles({});

    const { repaymentRate } = props

    const listContext = useListContext(props);

    // console.log(listContext)

    const isXSmall = useMediaQuery<Theme>(theme =>
        theme.breakpoints.down('sm')
    );

    // console.log(currencyFormatter().resolvedOptions())

    return <>
        {!isXSmall &&
            <ListToolbar
                filters={transactionFilters}
                actions={cloneElement(<ListActions />, { importer: false })}
            />
        }
        <Card>
            <CardContent className={classes.cardChart}>
                <StackedBarchart
                    repaymentRate={repaymentRate}
                    {...listContext}
                />
            </CardContent>
        </Card>

        <Box style={{ maxWidth: '100%', overflowX: "auto" }}>
            <Datagrid
                // size="small"
                optimized
                {...props}
            >
                {/* {!isXSmall && <NumberField source="id" />} */}
                <DateField source="timestamp" locales={dateLocales} options={{ ...defaultDateOptions, dateStyle: 'short' }} />
                {/* {!isXSmall && <ChipField size="small" className={classes.chipFinancing} source="financing_id" />} */}
                <CustomNumberField
                    source="collections.aggregate.sum.gross_sales"
                    sortable={false}
                    label="resources.Merchant.dashboard.gross_sale"
                    divisor={100}
                    locales="en-US"
                    // className={classes.amount}
                    options={currencyFormatter().resolvedOptions()}
                />
                <CustomNumberField
                    source="value"
                    sortable={false}
                    label="resources.Merchant.dashboard.repayment"
                    divisor={100}
                    locales="en-US"
                    // className={classes.amount}
                    options={currencyFormatter().resolvedOptions()}
                />
                <CustomNumberField
                    source="transfer_to_merchant"
                    sortable={false}
                    label="resources.Merchant.dashboard.transfer_to_merchant"
                    divisor={100}
                    className={classes.amount}
                    locales="en-US"
                    options={currencyFormatter().resolvedOptions()}
                />
            </Datagrid>
        </Box>
        <CustomPagination />
    </>
}


export default ListChartView